module.exports = __webpack_public_path__ + "img/too-busy.9480e651.png";